import { render, staticRenderFns } from "./CurrencyView.vue?vue&type=template&id=3f3ef6af"
import script from "./CurrencyView.vue?vue&type=script&lang=js"
export * from "./CurrencyView.vue?vue&type=script&lang=js"
import style0 from "./CurrencyView.vue?vue&type=style&index=0&id=3f3ef6af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports